import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { UItoggle } from './UItoggle';

export function UIradio({
  horizontal = false,
  vertical = true,
  options = [] }) {
  const context = useContext(Context);
  return (
    <>
      {vertical && <>

        {options.map(oneOption => {
          return (
            <div className="l_info_line">

              <UItoggle
                radio
                active={false}
                label={oneOption['title']}
                left
              />

            </div>

          )
        })}

      </>}
    </>
  )
}